module.exports = __webpack_public_path__ + "media/bootstrap-icons/command-fc9ebc85.svg";